export const rangoFechas = {
  desde: "Od",
  hasta: "Do",
  etiqueta: "Daty",
  quitar: "Usuń daty",
  titulo: "Wybierz daty",
  elegirInicio: "Dotknij pierwszego dnia",
  elegirFin: "Teraz dotknij ostatniego dnia",
  dias: "dzień | dni",
  anterior: "Poprzedni miesiąc",
  siguiente: "Następny miesiąc",
  cancelar: "Anuluj",
  aplicar: "Zastosuj",
};
